$eve_app_page_components_badge $eve_app_page_sb_page
	title \Badge
	Head null
	body /
		<= Overview_page $eve_app_page_sb_page
			title null
			body /
				<= Playground $eve_app_page_sb_playground
					component_name \Live_badge
					default_source \
						\Live_badge $eve_badge
						\	value \7
						\	colors \danger
						\
